// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__Pb7Fl","tabBtn":"Tabs_tabBtn__QP3i5","active":"Tabs_active__-Vjwf"};